// Libs
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

// Selectors
import orderTestsOperation$ from 'hfty-order-tests-dom/src/selectors/orderTestsOperation'

// Component
import Checkout from 'hfty-checkout/src/components/Checkout'

const mapStateToProps = (state) => ({
  operation: orderTestsOperation$(state),
})

const mapDispatchToProps = {
  push,
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout)
